<div class="with-floating-button">
    <div class="content" *ngIf="(accueilDetailService.accueil$ | async) as accueil; else loading">
        <page-header
                [title]="accueilDetailService.isCreation ? ('admin.bibliotheque.notifications.accueil.detail.titleAjout' | translate)
                    : ('admin.bibliotheque.notifications.accueil.detail.titleModification' | translate ) "
                [listeItems]="listeTabItems"
                (onGoBack)="onGoBack()"
        ></page-header>

        <form #form="ngForm">
            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.bibliotheque.notifications.accueil.detail.titleMessage'"></span>
                </mat-card-title>
                <mat-card-content>

                    <div class="row">
                        <!-- Objet -->
                        <custom-input ngDefaultControl
                                      name="objet"
                                      customType="input"
                                      libelle="admin.bibliotheque.notifications.accueil.detail.objet"
                                      [(ngModel)]="accueil.objet"
                                      [maxlength]="2000"
                                      [required]="true">
                        </custom-input>
                        <!-- Actif -->
                        <custom-input ngDefaultControl
                                      name="actif"
                                      customType="checkbox"
                                      libelle="admin.bibliotheque.notifications.accueil.detail.actif"
                                      [ngModel]="accueil.actif"
                                      [(customModel)]="accueil.actif">
                        </custom-input>
                    </div>

                    <div class="row">
                        <!-- Type -->
                        <custom-input ngDefaultControl
                                      name="type"
                                      customType="select"
                                      libelle="admin.bibliotheque.notifications.accueil.detail.type"
                                      [(ngModel)]="accueil.type"
                                      [selectOptions]="listeTypes"
                                      optionValue="id"
                                      optionDisplay="libelle"
                                      [required]="true">
                        </custom-input>
                        <!-- Date début -->
                       <custom-input ngDefaultControl
                                     name="dateDebut"
                                     customType="date"
                                     libelle="admin.bibliotheque.notifications.accueil.detail.dateDebut"
                                     [ngModel]="accueil.dateDebut"
                                     [(customModel)]="accueil.dateDebut">
                       </custom-input>
                   </div>

                    <div class="row">
                        <!-- Date du dernier envoi de l'email -->
                        <label class="col-md-2">
                            <span [translate]="'admin.bibliotheque.notifications.accueil.detail.email'"></span>
                        </label>
                        <div class="col-md-4 d-flex flex-row align-items-center">
                            <ng-container *ngIf="accueil.dateEnvoi != null; else noEmail;">
                                {{ 'admin.bibliotheque.notifications.accueil.detail.emailMessage' | translate:{'date': accueil.dateEnvoi | date:'shortDate'} }}
                            </ng-container>
                            <ng-template #noEmail>
                                {{ 'admin.bibliotheque.notifications.accueil.detail.noEmailMessage' | translate }}
                            </ng-template>
                        </div>

                        <!-- Date fin -->
                        <custom-input ngDefaultControl
                                      name="dateFin"
                                      customType="date"
                                      libelle="admin.bibliotheque.notifications.accueil.detail.dateFin"
                                      [ngModel]="accueil.dateFin"
                                      [(customModel)]="accueil.dateFin">
                        </custom-input>
                    </div>

                    <!-- Message -->
                    <div class="row">
                        <custom-input ngDefaultControl
                                      name="message"
                                      customType="textarea"
                                      libelle="admin.bibliotheque.notifications.accueil.detail.message"
                                      [(ngModel)]="accueil.message"
                                      [maxlength]="2000"
                                      rCol="10"
                                      [required]="true">
                        </custom-input>
                    </div>
                </mat-card-content>
            </mat-card>

            <!--Affichage de la liste des rôles-->
            <list-view *ngIf="listeRole" [liste]="listeRole"></list-view>
        </form>
    </div>
    <floating-button [listeActions]="listeActions" [isPending]="accueilDetailService.isSaving"></floating-button>
</div>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>
